export const schoolsApi = {
  server: {
    header: '/api/bff/org/optimized-header/',
    explore: '/api/v5/header-explorer/',
    school: (slug: string) => `/api/v5/school/${slug}/`,
    community: (slug: string) => `/api/v5/school/${slug}/community_info/`,
    identity: '/api/v5/users/identity/',
    route: (slug: string) => `/api/v5/learning-path/${slug}/`,
    contactInfo: '/api/bff/web/contact-info/',
    bannerData: '/api/v5/banner-data/',
  },
  client: {
    schools: {
      getFollowSchools: `/api/v4/user-learning-paths/`,
      followSchool: (schoolId: number) => `/api/v4/user-learning-paths/${schoolId}/assign/`,
      unFollowSchool: (schoolId: number) => `/api/v4/user-learning-paths/${schoolId}/`,
      challenges: (ids: string) => `/api/v1/info/?related_learning_path_ids=${ids}`,
      placement_test: (schoolSlug: string) => `/api/v5/school/${schoolSlug}/placement_test/`,
      routesProgress: (schoolSlug: string) => `/api/v5/school/${schoolSlug}school_progress/`,
    },
    routes: {
      routeProgress: (id: number) => `/api/v5/learning-path/${id}/progress/`,
    },
    registerEmail: '/webhookemail/hola/',
    userPlans: '/api/v4/landing/plans/?hide=b2b_plan',
    tablePrice: '/plans/v1/table-price/',
    b2bPlans: '/api/v4/b2b/landing/plans/',
  },
};
